import {useCallback} from 'react'

import {StoreVariant} from '../../api/store'
import {useVenue} from '../../api/venue/hooks'
import {useLocale} from '../../utils/i18n'

/** Resolve the chosen option values to a concrete variant, or null while the
 *  selection is still incomplete. Shared by the product page and the quick-buy
 *  sheet so both price the same selection identically. */
export const matchVariant = (
  options: {name: string; values: string[]}[],
  variants: Record<string, StoreVariant>,
  selection: Record<string, string>,
): {variantId: string; variant: StoreVariant} | null => {
  if (options.some((option) => !selection[option.name])) {
    return null
  }
  const found = Object.entries(variants).find(([, variant]) =>
    options.every((option) => variant.optionValues[option.name] === selection[option.name]),
  )
  return found ? {variantId: found[0], variant: found[1]} : null
}

export const useCurrencyFormat = () => {
  const {l} = useLocale()
  const {data: venue} = useVenue()
  return useCallback(
    (value: number | null | undefined) =>
      value === null || value === undefined ? '' : l(`${venue?.currency || ''}_symbolic`, {value}),
    [l, venue?.currency],
  )
}

export const ORDER_STATUS_LOCALE: Record<string, string> = {
  PLACED: 'store-status-placed',
  PROCESSING: 'store-status-processing',
  READY_FOR_PICKUP: 'store-status-ready',
  COMPLETED: 'store-status-completed',
  CANCELLED: 'store-status-cancelled',
}
